"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolloutStrategyAttributeConditional = void 0;
var RolloutStrategyAttributeConditional;
(function (RolloutStrategyAttributeConditional) {
    RolloutStrategyAttributeConditional["Equals"] = "EQUALS";
    RolloutStrategyAttributeConditional["EndsWith"] = "ENDS_WITH";
    RolloutStrategyAttributeConditional["StartsWith"] = "STARTS_WITH";
    RolloutStrategyAttributeConditional["Greater"] = "GREATER";
    RolloutStrategyAttributeConditional["GreaterEquals"] = "GREATER_EQUALS";
    RolloutStrategyAttributeConditional["Less"] = "LESS";
    RolloutStrategyAttributeConditional["LessEquals"] = "LESS_EQUALS";
    RolloutStrategyAttributeConditional["NotEquals"] = "NOT_EQUALS";
    RolloutStrategyAttributeConditional["Includes"] = "INCLUDES";
    RolloutStrategyAttributeConditional["Excludes"] = "EXCLUDES";
    RolloutStrategyAttributeConditional["Regex"] = "REGEX";
})(RolloutStrategyAttributeConditional = exports.RolloutStrategyAttributeConditional || (exports.RolloutStrategyAttributeConditional = {}));
//# sourceMappingURL=rollout-strategy-attribute-conditional.js.map